<div class="sg-avatar sg-ui-component" [sgTooltip]="showTooltip ? fullName : ''" [ngClass]="avatarSizeClass" style.background="var({{ getAvatarColor() }})">
  <sg-text [variant]="textVariant" [withoutLineHeight]="true">{{ initials }}</sg-text>
</div>
